module.exports = __webpack_public_path__ + "static/media/on1.5a34a0c6.png";